import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function PeoplePage() {
  return (
    <SectionLayout title="People">
      {/* People content will go here */}
    </SectionLayout>
  );
} 